import axios from "axios";
import { API_BASE_URL, AUTH_API_BASE_URL } from "../config/api-config";

export const apiWithAuth = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const apiWithoutAuth = axios.create({
  baseURL: AUTH_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
